import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { Formik, Form, Field, useFormikContext } from "formik";
import Swal from "sweetalert2";
import data from "../../data/villages.json";
import crops from "../../data/crop.json";
import { InputField, DatePicker, InputAutocomplete } from "../../elements";
import { nocTractorStyles } from "./nocTractor.styles";
import { fetchTractorRequest } from "../../store/actions/tractorAction";
import { fetchManufacturerRequest } from "../../store/actions/fetchManufacturerAction";
import {
  addFdwEnquiryRequest,
  resetAddFdwEnquiryForm,
} from "../../store/actions/addFdwEnquiryAction";
import { connect } from "react-redux";
import { formatDateInYYMMDD } from "../../utils";

const SetData = ({
  setDistrictArr,
  setTalukaArr,
  setVillageArr,
  districtArr,
  talukaArr,
  newData,
  manufacturers,
  models,
  setModelOptions,
}) => {
  const { values, setFieldValue } = useFormikContext();

  useEffect(() => {
    if (data && Object.keys(data).includes(values.state)) {
      let districts = Object.keys(data[values.state]);
      const districtList = districts.map((district) => ({
        value: district,
      }));
      setDistrictArr(districtList);
    }
    setFieldValue("district", "", false);
    setFieldValue("taluka", "", false);
    setFieldValue("village", "", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.state]);

  useEffect(() => {
    if (
      data &&
      Object.keys(data).includes(values.state) &&
      districtArr.find((d) => d.value === values.district)
    ) {
      let talukas = Object.keys(data[values.state][values.district]);
      const talukaList = talukas.map((taluka) => ({
        value: taluka,
      }));

      setTalukaArr(talukaList);
    }
    setFieldValue("taluka", "", false);
    setFieldValue("village", "", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.district]);

  useEffect(() => {
    if (
      data &&
      Object.keys(data).includes(values.state) &&
      districtArr.find((d) => d.value === values.district) &&
      talukaArr.find((d) => d.value === values.tehsil)
    ) {
      let villages = data[values.state][values.district][values.tehsil];
      const villageList = villages.map((village) => ({
        value: village,
      }));

      setVillageArr(villageList);
    }
    setFieldValue("village", "", false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.tehsil]);

  useEffect(() => {
    if (
      newData &&
      manufacturers.find((item) => item.value === values.manufacturer)
    ) {
      let filteredData = newData.filter(
        (item) => item.manufacturer === values.manufacturer
      );
      let filteredModel = filteredData.map((item) => item.model);
      filteredModel = [...new Set(filteredModel)];
      filteredModel = filteredModel.map((item) => ({
        value: item,
      }));
      setModelOptions(filteredModel);
      setFieldValue("model", "", false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.manufacturer]);

  useEffect(() => {
    setFieldValue("wantToExchange", "", false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.alreadyOwnTractor]);

  return null;
};

const NocTractor = ({ ...props }) => {
  const classes = nocTractorStyles();
  const history = useHistory();
  const location = useLocation();
  const [tractorOptions, setTractorOptions] = useState([]);
  const [manufacturerOptions, setManufacturerOptions] = useState([]);
  const [modelOptions, setModelOptions] = useState([]);
  const [stateArr, setStateArr] = useState([]);
  const [districtArr, setDistrictArr] = useState([]);
  const [talukaArr, setTalukaArr] = useState([]);
  const [villageArr, setVillageArr] = useState([]);
  const [cropsData, setCropsData] = useState([]);

  useEffect(() => {
    if (!props.tractors) {
      props.getTractors();
    }
    if (!props.manufacturers) {
      props.getManufacturers();
    }
    const stateValue = Object.keys(data);
    const stateList = stateValue.map((state) => ({
      value: state,
    }));
    setStateArr(stateList);

    const cropValue = Object.values(crops.crop_arr);
    const unique = [...new Set(cropValue)];
    const cropList = unique.map((crop) => ({
      value: crop,
    }));
    cropList.sort((a, b) => (a.value > b.value ? 1 : -1));
    setCropsData(cropList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function formatLabel(str) {
    str = str.split("-");
    str.shift();
    str = str.join("-").trim();

    return str;
  }
  useEffect(() => {
    if (props.tractors) {
      let list = props.tractors.map((tractor) => ({
        label: formatLabel(tractor.tractor_name),
        value: tractor.tractor_name,
      }));
      list.sort((a, b) => (a.value > b.value ? 1 : -1));
      setTractorOptions(list);
    }
  }, [props.tractors]);

  useEffect(() => {
    if (props.manufacturers) {
      let uniqueManufacturerList = [
        ...new Set(props.manufacturers.map((item) => item.manufacturer)),
      ];
      uniqueManufacturerList = uniqueManufacturerList.map((item) => ({
        value: item,
      }));
      uniqueManufacturerList.sort((a, b) => (a.value > b.value ? 1 : -1));
      setManufacturerOptions(uniqueManufacturerList);
    }
  }, [props.manufacturers]);

  useEffect(() => {
    if (props.enquiryResponse) {
      Swal.fire({
        icon: props.enquiryResponse.status.toLowerCase(),
        text: props.enquiryResponse.message,
      }).then((res) => {
        if (res) {
          props.resetSubmitEnquiry();
          history.push("/noc");
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.enquiryResponse]);

  return (
    <div className={classes.root}>
      <div className={classes.contentWrapper}>
        <h2>Tractor Enquiry</h2>
        <Formik
          initialValues={{
            customerType: "",
            companyName: "",
            date: new Date(),
            salutation: "",
            firstName: "",
            lastName: "",
            fathersName: "",
            expectedDeliveryDate: new Date(),
            visited: "",
            firstVisitDate: new Date(),
            mobileNumber: location?.state?.mobile ?? "",
            preferredAddress: "",
            address: "",
            village: "",
            tehsil: "",
            district: "",
            state: "",
            pincode: "",
            buyer: "",
            alreadyOwnTractor: "",
            wantToExchange: "",
            mahindraModel: "",
            farmingLand: "10",
            cropsV: "",
            irrigatedLand: "10",
            nonIrrigated: "",
            model: "",
            manufacturer: "",
            purchaseYear: "",
            modeOfFinance: "004 TBD",
            sourceOfEnquiry: "003 Referral",
            subSource: "Krish-e",
          }}
          validate={(values) => {
            const errors = {};
            if (values.firstName === "") {
              errors.firstName = "*Required Field";
            }
            if (values.lastName === "") {
              errors.lastName = "*Required Field";
            }
            if (values.fathersName === "") {
              errors.fathersName = "*Required Field";
            }
            if (values.mobileNumber === "") {
              errors.mobileNumber = "*Required Field";
            }
            if (values.address === "") {
              errors.address = "*Required Field";
            }
            if (values.village === "") {
              errors.village = "*Required Field";
            }
            if (values.tehsil === "") {
              errors.tehsil = "*Required Field";
            }
            if (values.district === "") {
              errors.district = "*Required Field";
            }
            if (values.state === "") {
              errors.state = "*Required Field";
            }
            if (values.pincode === "") {
              errors.pincode = "*Required Field";
            }
            if (values.mahindraModel === "") {
              errors.mahindraModel = "*Required Field";
            }
            if (values.irrigatedLand === "") {
              errors.irrigatedLand = "*Required Field";
            }
            return errors;
          }}
          onSubmit={(values, { setSubmitting }) => {
            let {
              customerType,
              companyName,
              salutation,
              firstName,
              lastName,
              fathersName,
              expectedDeliveryDate,
              firstVisitDate,
              mobileNumber,
              address,
              village,
              tehsil,
              district,
              state,
              pincode,
              buyer,
              mahindraModel,
              alreadyOwnTractor,
              wantToExchange,
              farmingLand,
              irrigatedLand,
              cropsV,
              model,
              manufacturer,
              purchaseYear,
              modeOfFinance,
              sourceOfEnquiry,
              subSource,
            } = values;
            let expectedDate = formatDateInYYMMDD(expectedDeliveryDate);
            let visitDate = formatDateInYYMMDD(firstVisitDate);
            let preferredAddress;
            let customer =
              customerType === "Individual" ? "001 Individual" : "002 Company";
            let salu;
            if (salutation === "MR") {
              salu = "31 MR";
            } else if (salutation === "MRS") {
              salu = "33 MRS";
            } else {
              salu = " 35 MS";
            }
            let buyerType;
            if (alreadyOwnTractor === "Yes") {
              if (wantToExchange === "Yes") {
                buyerType = "003 Exchange(BUY BACK)";
              } else {
                if (buyer === "Brand New") {
                  buyerType = "002 Additional New";
                } else {
                  buyerType = "005 Additional Second Hand";
                }
              }
            } else {
              if (buyer === "Brand new") {
                buyerType = "001 FTB";
              } else {
                buyerType = "004 Second Hand FTB";
              }
            }

            if (values.customerType === "Individual") {
              preferredAddress = "Residential";
            } else {
              preferredAddress = "Office";
            }

            let tractorName = tractorOptions.find(
              (tractor) => tractor.label === mahindraModel
            );
            tractorName = tractorName.value ?? mahindraModel;

            let nonIrrigatedLand = farmingLand - irrigatedLand;

            let manufacturerCode;
            let modelCode;
            let manufacturerData = props.manufacturers.filter(
              (item) =>
                item.manufacturer === manufacturer && item.model === model
            );
            if (manufacturerData.length > 0) {
              manufacturerCode = manufacturerData[0].manufacturer_code;
              modelCode = manufacturerData[0].model_code;
            }
            let requestData = {
              typeOfProduct: "11",
              originSource: "Carnot NOC",
              strCustomerType: customer,
              strCompanyName: companyName,
              strSalutation: salu,
              strFirstName: firstName,
              strLastName: lastName,
              strFathersName: fathersName,
              strExpectedDeliverydate: expectedDate,
              strFirstVisitDate: visitDate,
              strMobileNo: mobileNumber,
              strPreferredAddress: preferredAddress,
              strAddress: address,
              strVillage: village,
              strTehsil: tehsil,
              strDistrict: district,
              strState: state,
              strPincode: pincode,
              strTypeofBuyer: buyerType,
              strModeofFinance: modeOfFinance,
              strSourceofEnquiry: sourceOfEnquiry,
              strSubSourceofEnquiry: subSource,
              strTraIntrestedModel: tractorName,
              strIrrigatedLand: irrigatedLand,
              strNonirrigatedland: nonIrrigatedLand,
              strCrop: cropsV,
              strExistsManufacture: manufacturerCode ?? "",
              strExistsModel: modelCode ?? "",
              strExistsYop: purchaseYear,
            };
            props.submitEnquiry({ requestData });
            setSubmitting(false);
          }}
        >
          {({ values, errors, touched, handleChange }) => (
            <Form>
              <div className={classes.inputWrapper}>
                <h4>Tractor Required By</h4>
                <Field
                  name="customerType"
                  id="customer-type"
                  label="Customer Type"
                  defaultValue="Individual"
                  labelWidth={110}
                  options={[
                    {
                      label: "Individual",
                      value: "Individual",
                    },
                    {
                      label: "Company",
                      value: "Company",
                    },
                  ]}
                  component={InputAutocomplete}
                />
              </div>
              {values.customerType === "Company" && (
                <div className={classes.inputWrapper}>
                  <h4>Company Name</h4>
                  <Field
                    name="companyName"
                    id="Company-name"
                    label="Company Name"
                    labelWidth={120}
                    type="text"
                    component={InputField}
                  />
                </div>
              )}
              <div className={classes.inputWrapper}>
                <h4>Salutation </h4>
                <Field
                  name="salutation"
                  id="Salutation"
                  label="Salutation"
                  labelWidth={110}
                  defaultValue="MR"
                  options={[
                    {
                      label: "MR",
                      value: "MR",
                    },
                    {
                      label: "MRS",
                      value: "MRS",
                    },
                    {
                      label: "MS",
                      value: "MS",
                    },
                  ]}
                  component={InputAutocomplete}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>First Name</h4>
                <Field
                  name="firstName"
                  id="first-name"
                  label="First Name"
                  labelWidth={85}
                  type="text"
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Last Name</h4>
                <Field
                  name="lastName"
                  id="last-name"
                  label="Last Name"
                  labelWidth={80}
                  type="text"
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Father's Name</h4>
                <Field
                  name="fathersName"
                  id="fathers Name"
                  label="Father's Name"
                  labelWidth={110}
                  type="text"
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Expected Purchase Date</h4>
                <Field name="expectedDeliveryDate" component={DatePicker} />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Have you visited dealership before?</h4>
                <Field
                  name="visited"
                  id="visited-type"
                  label="Have you visited dealership before"
                  defaultValue="No"
                  labelWidth={250}
                  options={[
                    {
                      label: "Yes",
                      value: "Yes",
                    },
                    {
                      label: "No",
                      value: "No",
                    },
                  ]}
                  component={InputAutocomplete}
                />
              </div>
              {values.visited === "Yes" && (
                <div className={classes.inputWrapper}>
                  <h4>First Visit Date</h4>
                  <Field name="firstVisitDate" component={DatePicker} />
                </div>
              )}
              <div className={classes.inputWrapper}>
                <h4>Mobile Number</h4>
                <Field
                  name="mobileNumber"
                  id="mobile Number"
                  label="Mobile Number"
                  labelWidth={120}
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>State</h4>
                <Field
                  name="state"
                  id="stateName"
                  label="State"
                  labelWidth={40}
                  // type="text"
                  options={stateArr}
                  component={InputAutocomplete}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>District</h4>
                <Field
                  name="district"
                  id="DistrictName"
                  label="District"
                  labelWidth={60}
                  // type="text"
                  options={districtArr}
                  component={InputAutocomplete}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Tehsil</h4>
                <Field
                  name="tehsil"
                  id="TehsilName"
                  label="Tehsil Name"
                  labelWidth={100}
                  // type="text"
                  options={talukaArr}
                  component={InputAutocomplete}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Village</h4>
                <Field
                  name="village"
                  id="villageName"
                  label="Village"
                  labelWidth={50}
                  type="text"
                  options={villageArr}
                  component={InputAutocomplete}
                  // component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Pincode</h4>
                <Field
                  name="pincode"
                  id="Pincode"
                  label="Pincode"
                  labelWidth={60}
                  type="number"
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Landmark</h4>
                <Field
                  name="address"
                  id="full-address"
                  label="Landmark"
                  labelWidth={70}
                  multiline
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Do you already own tractor?</h4>
                <Field
                  name="alreadyOwnTractor"
                  id="already-own-tractor"
                  label="Do you already own tractor "
                  labelWidth={250}
                  options={[
                    {
                      label: "Yes",
                      value: "Yes",
                    },
                    {
                      label: "No",
                      value: "No",
                    },
                  ]}
                  component={InputAutocomplete}
                />
              </div>
              {values.alreadyOwnTractor === "Yes" && (
                <div className={classes.inputWrapper}>
                  <h4>Do you want to exchange?</h4>
                  <Field
                    name="wantToExchange"
                    id="want-to-exchange"
                    label="Do you want to exchange"
                    labelWidth={250}
                    options={[
                      {
                        label: "Yes",
                        value: "Yes",
                      },
                      {
                        label: "No",
                        value: "No",
                      },
                    ]}
                    component={InputAutocomplete}
                  />
                </div>
              )}
              {values.alreadyOwnTractor === "No" && (
                <div className={classes.inputWrapper}>
                  <h4>Type of Purchase</h4>
                  <Field
                    name="buyer"
                    id="buyer"
                    label="Type of Purchase"
                    labelWidth={100}
                    options={[
                      {
                        label: "Brand new",
                        value: "Brand new",
                      },
                      {
                        label: "Second hand",
                        value: "Second hand",
                      },
                    ]}
                    component={InputAutocomplete}
                  />
                </div>
              )}
              {values.wantToExchange === "No" && (
                <div className={classes.inputWrapper}>
                  <h4>Type of Purchase</h4>
                  <Field
                    name="buyer"
                    id="buyer"
                    label="Type of Purchase"
                    labelWidth={100}
                    options={[
                      {
                        label: "Brand New",
                        value: "Brand New",
                      },
                      {
                        label: "Second Hand",
                        value: "Second Hand",
                      },
                    ]}
                    component={InputAutocomplete}
                  />
                </div>
              )}
              {(values.wantToExchange === "Yes" ||
                values.buyer === "Brand New" ||
                values.buyer === "Second Hand") && (
                <div>
                  <div className={classes.inputWrapper}>
                    <h4>Manufacturer of the last tractor purchased</h4>
                    <Field
                      name="manufacturer"
                      id="manufacturerName"
                      label="Manufacturer of the last tractor purchased"
                      labelWidth={100}
                      // type="text"
                      options={manufacturerOptions}
                      component={InputAutocomplete}
                    />
                  </div>
                  <div className={classes.inputWrapper}>
                    <h4>Model of the last tractor purchased</h4>
                    <Field
                      name="model"
                      id="modelName"
                      label="Model of the last tractor purchased"
                      labelWidth={40}
                      // type="text"
                      options={modelOptions}
                      component={InputAutocomplete}
                    />
                  </div>
                  <div className={classes.inputWrapper}>
                    <h4>Year of last tractor Purchase</h4>
                    <Field
                      name="purchaseYear"
                      id="purchase"
                      label="Year of last tractor Purchase"
                      labelWidth={210}
                      type="number"
                      component={InputField}
                    />
                  </div>
                </div>
              )}
              <div className={classes.inputWrapper}>
                <h4>Mahindra Model</h4>
                <Field
                  name="mahindraModel"
                  id="Mahindra-model"
                  label="Mahindra Model"
                  labelWidth={120}
                  options={tractorOptions}
                  component={InputAutocomplete}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Total Land Owned for Farming</h4>
                <Field
                  name="farmingLand"
                  id="farming-land"
                  label="Total Land Owned for Farming"
                  labelWidth={250}
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Irrigated Land (In Acres)</h4>
                <Field
                  name="irrigatedLand"
                  id="irrigated"
                  label="Irrigated Land"
                  labelWidth={100}
                  component={InputField}
                />
              </div>
              <div className={classes.inputWrapper}>
                <h4>Crops</h4>
                <Field
                  name="cropsV"
                  id="cropName"
                  label="Crops"
                  labelWidth={40}
                  // type="text"
                  options={cropsData}
                  component={InputAutocomplete}
                />
              </div>
              <SetData
                districtArr={districtArr}
                talukaArr={talukaArr}
                setDistrictArr={setDistrictArr}
                setTalukaArr={setTalukaArr}
                setVillageArr={setVillageArr}
                newData={props?.manufacturers}
                manufacturers={manufacturerOptions}
                models={modelOptions}
                setModelOptions={setModelOptions}
              />
              <div className={classes.submitAlign}>
                <button
                  type="submit"
                  className={classes.submit}
                  // disabled={props.enquiryLoading}
                >
                  {props.enquiryLoading ? "Submitting.." : "Submit"}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  tractors: state.tractorReducer.tractors,
  tractorLoading: state.tractorReducer.loading,
  manufacturers: state.manufacturerReducer.manufacturer,
  manufacturerLoading: state.manufacturerReducer.loading,
  enquiryLoading: state.fdwEnquiryReducer.loading,
  enquiryResponse: state.fdwEnquiryReducer.res,
});
const mapDispatchToProps = (dispatch) => ({
  getTractors: () => dispatch(fetchTractorRequest()),
  getManufacturers: () => dispatch(fetchManufacturerRequest()),
  submitEnquiry: ({ requestData }) =>
    dispatch(addFdwEnquiryRequest({ requestData })),
  resetSubmitEnquiry: () => dispatch(resetAddFdwEnquiryForm()),
});

export default connect(mapStateToProps, mapDispatchToProps)(NocTractor);
